import React from 'react'
import { ProgressSpinner } from 'primereact/progressspinner'

export default function Loading({ size = 'sm' }) {
  const styles = {
    xs: { width: 20, height: 20 },
    sm: { width: 40, height: 40 },
    md: { width: 60, height: 60 },
  }
  return <ProgressSpinner style={styles[size]} />
}
